export interface JobRelatedEntity {
  refDataLinkParentId: string;
  createDateUtc: Date | string;
  createWebUserId: string;
  modifyDateUtc: Date | string;
  modifyWebUserId: string;
  jobId?: string;
  auditId?: string;
  invoiceId?: string;
  followUpActionId?: string;
  requestId?: string;
  quoteId?: string;
  assetId?: string;
  iotAlertId?: string;
  entityType: entityType;
  entityTypeDisplay: string;
}

export interface JobParentRelatedEntity extends JobRelatedEntity {
  description: string;
}

export interface JobChildRelatedEntity extends JobRelatedEntity {
  refDataLinkChildId: string;
}

export interface JobParentRelatedEntities {
  jobParentRelatedEntities: JobParentRelatedEntity[];
}

export interface JobChildRelatedEntities {
  jobChildRelatedEntities: JobChildRelatedEntity[];
}

export enum entityType {
  Job,
  Audit,
  Invoice,
  FollowUpAction,
  Request,
  Quote,
  Asset,
  IoTAlert,
  None
}
